import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

/**
 * Live-tracks the `prefers-reduced-motion: reduce` media query so blink-style
 * UI (the composer's block caret — spec 007 T8.2, a streaming message's
 * trailing cursor — T8.3) can fall back to a static-but-visible state instead
 * of animating. `matchMedia` itself is synchronous, but the `change`
 * listener is the async surface that needs the usual effect-cleanup guard
 * (`.claude/rules/react.md`).
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY).matches : false,
  )

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(QUERY)
    let cancelled = false
    const handleChange = () => {
      if (!cancelled) setReduced(mql.matches)
    }
    handleChange()
    mql.addEventListener('change', handleChange)
    return () => {
      cancelled = true
      mql.removeEventListener('change', handleChange)
    }
  }, [])

  return reduced
}
